import { Component, HostBinding } from '@angular/core';
import { environment } from '@env';
import { SidebarComponent } from '../sidebar/sidebar.component';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-content-layout',
    templateUrl: './content-layout.component.html',
    styleUrls: ['./content-layout.component.scss'],
    imports: [SidebarComponent, RouterOutlet]
})
export class ContentLayoutComponent {
  @HostBinding('class.showSidebar') showSidebar = environment.showSideBar;


}
